<div class="flex flex-col justify-between items-start mt-4 gap-3">
  <label class="label cursor-pointer gap-3" @fadeInOut>
    <div class="font-spaceGrotesk font-medium text-[16px]">Alerts Enabled</div>
    <input
      [(ngModel)]="alertThresholdEnabled"
      (ngModelChange)="onAlertToggleChanged($event)"
      class="toggle toggle-sm"
      type="checkbox"
      />
  </label>

  @if (alertThresholdEnabled) {
    <div class="flex justify-between items-center w-full">
      <div class="flex gap-2 mt-2 items-center inter-300 text-[14px] text-support-text">
        <div class="mr-2">Trigger alert if</div>
        <div class="bg-textbox-fill border border-textbox-border rounded-[8px] px-3 py-1.5 inter-300 text-[14px] text-support-text flex items-center justify-center"><span>Score</span></div>
        <select class="bg-textbox-fill border border-textbox-border rounded-full px-3 py-1.5 inter-300 text-[14px] text-support-text appearance-none focus:outline-none" [(ngModel)]="questionSet.alertThreshold!.operator">
          @for (operator of AlertThresholdOperator | keyvalue:unsorted; track operator) {
            <option [value]="operator.key">{{ operator.value }}</option>
          }
        </select>
        <input class="bg-textbox-fill border border-textbox-border rounded-[8px] px-3 py-1.5 w-[80px] inter-300 text-[14px] outline-none" type="number" [(ngModel)]="questionSet.alertThreshold!.threshold" />
      </div>
      <div class="flex gap-2 mt-2 items-center">
        <div class="inter-500 text-[14px] text-support-text">Severity Level</div>
        <select class="bg-textbox-fill border border-textbox-border rounded-full px-3 py-1.5 inter-300 text-[14px] text-support-text appearance-none focus:outline-none" [(ngModel)]="questionSet.alertThreshold!.alertSeverityLevel">
          <option [value]="'Low'">Low</option>
          <option [value]="'Medium'">Medium</option>
          <option [value]="'High'">High</option>
        </select>
      </div>
    </div>
  }
</div>
